import * as React from 'react';
const SvgEdit = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.85 2.85a3.042 3.042 0 0 1 4.3 4.3l-9.222 9.223c-.19.19-.426.329-.683.403l-4.33 1.237a.75.75 0 0 1-.928-.928l1.237-4.329a1.6 1.6 0 0 1 .403-.685zm1.06 1.06a1.542 1.542 0 0 1 2.18 2.18l-.72.72-2.18-2.18zm-1.78 1.78-7.442 7.442a.1.1 0 0 0-.021.035L3.8 16.2l3.03-.866a.1.1 0 0 0 .038-.022L14.31 7.87z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgEdit;
